import useGetUnresolvedOrderByProductId from './useGetUnresolvedOrderByProductId'

export default useGetUnresolvedOrderByProductId
